import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { getFeature } from '../../../DaEditorWrapper/Features';
import { FIRST_IMAGE_FEATURE } from '../../../DaEditorWrapper/Features/firstImage';
import { styleFromWidthHeight, getIsShortStatus } from '../../_helpers';
import MediaService, { fallbackToLargestFile, } from '../../../utils/DeviationMediaService';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import s from './Status.scss';
export function getStatusImage(deviation) {
    var backgroundItem;
    if (deviation.textContent.html.type === 'writer') {
        var statusItems = deviation.status.items || [];
        var bg = statusItems.find(function (item) { return item.type === 'thumb_background_deviation'; });
        backgroundItem = (bg && bg.deviation) || undefined;
    }
    else {
        var first = getFeature(FIRST_IMAGE_FEATURE, deviation.textContent.html.features);
        if (first) {
            backgroundItem = first.data.deviation;
        }
    }
    return backgroundItem;
}
function getBackgroundAttributes(deviation, width, height) {
    var backgroundItem = getStatusImage(deviation);
    if (backgroundItem) {
        var bgFile = MediaService.getSmallestThumbThatFullyCovers(backgroundItem, width, height, fallbackToLargestFile);
        if (bgFile) {
            return {
                backgroundImage: "url('" + bgFile.src + "')",
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'center',
                backgroundPositionY: 'top',
                backgroundSize: 'cover',
            };
        }
    }
    return {};
}
export var Status = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, className = _a.className, _b = _a.responsive, responsive = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var status = deviation.status, textContent = deviation.textContent;
    if (!status || !textContent) {
        return null;
    }
    var backgroundAttributes = getBackgroundAttributes(deviation, width, height);
    var style = styleFromWidthHeight({ width: width, height: height }, responsive);
    return (React.createElement("div", { className: classnames(s['root'], getIsShortStatus(deviation, true) ? s['short'] : s['long'], className), style: __assign(__assign({}, style), backgroundAttributes) },
        React.createElement("div", { className: s['overlay'] }),
        React.createElement("div", { className: s['body'] },
            React.createElement(ExcerptRenderer, { className: s['body-inner'], textContent: textContent, htmlExcerptLegacy: true, emptyPlaceHolder: "[" + t('deviationview.unknown.nopreview') + "]" }))));
};
Status.displayName = 'Status';
export default Status;
//# sourceMappingURL=Status.js.map